import { Controller } from 'stimulus';
import { initTooltips } from 'ez-styles/assets/js/utils/tooltips';
import {
  sendTrackingEvent,
  NEW_ANALYTICS_FEATURE,
  findCategoryByElement,
  trackCompleteEvent,
} from 'components/analytics/conversions/tracking';
import { JOIN_PRO_CLICK, JOIN_PRO_COMPLETE } from 'components/analytics/conversions/constants/actions';
import { featureEnabled } from 'lib/helpers';

export default class LicenseCompareModalController extends Controller {
  connect() {
    if (this.element.querySelectorAll('.ez-tooltip-icon').length > 0) {
      initTooltips();
    }
  }

  proClick(event) {
    if (!featureEnabled(NEW_ANALYTICS_FEATURE)) return;

    const category = findCategoryByElement(event.target);

    sendTrackingEvent({
      element: event.target,
      data: { action: JOIN_PRO_CLICK, category },
    });

    trackCompleteEvent({
      action: JOIN_PRO_COMPLETE,
      category,
    });
  }
}
